<template>
  <div class="list-card" @click="navigateToCollaborativeTaskList" @mouseenter="isTaskOptionsButtonShown = true"
       @mouseleave="isTaskOptionsButtonShown = false">
    <b-row>
      <b-col>
        <p class="list-name-text">{{ listDetails.toDoListName }}</p>
        <p v-if="listDetails.toDoListDescription" class="list-description-text">{{ listDetails.toDoListDescription
          }}</p>
        <p v-else class="list-description-text">No description provided.</p>
      </b-col>
      <b-col class="col-1 mr-2 center-align-icon">
        <font-awesome-icon v-if="isTaskOptionsButtonShown && isCollaborativeListOwner" class="task-option-button mt-1"
                           icon="sign-out-alt" @click.stop="isOwnerLeaveListModalShown = true"/>
        <font-awesome-icon v-else-if="isTaskOptionsButtonShown && !isCollaborativeListOwner"
                           class="task-option-button mt-1" icon="sign-out-alt"
                           @click.stop="isGeneralLeaveListModalShown = true"/>
        <font-awesome-icon v-if="isTaskOptionsButtonShown && isCollaborativeListOwner" class="task-option-button mt-3"
                           :icon="['far', 'trash-alt']" @click.stop="isDeleteListModalShown = true"/>
      </b-col>
    </b-row>

    <!-- List Options Modal -->
    <b-modal
        id="owner-leave-list-modal"
        title="Leave List"
        :visible="isOwnerLeaveListModalShown"
        @hide="isOwnerLeaveListModalShown = false"
        @ok="navigateToTransferListOwnership"
        scrollable
        ok-only
        ok-title="Leave list"
        ok-variant="danger"
        no-close-on-backdrop>
      <p class="task-option-modal-text">Are you sure you want to leave "<strong>{{ listDetails.toDoListName }}</strong>"?
        You will need to assign a new owner of the collaborative list.</p>
    </b-modal>

    <!-- List Options Modal -->
    <b-modal
        id="general-leave-list-modal"
        title="Leave List"
        :visible="isGeneralLeaveListModalShown"
        @hide="isGeneralLeaveListModalShown = false"
        @ok="leaveCollaborativeList"
        scrollable
        ok-only
        ok-title="Leave list"
        ok-variant="danger"
        no-close-on-backdrop>
      <p class="task-option-modal-text">Are you sure you want to leave "<strong>{{ listDetails.toDoListName }}</strong>"?
      </p>
    </b-modal>

    <!-- List Options Modal -->
    <b-modal
        id="delete-list-modal"
        title="Delete List"
        :visible="isDeleteListModalShown"
        @hide="isDeleteListModalShown = false"
        @cancel="isOwnerLeaveListModalShown = true"
        @ok="deleteList"
        scrollable
        cancel-title="Leave instead"
        cancel-variant="outline-primary"
        ok-title="Delete list"
        ok-variant="danger"
        no-close-on-backdrop>
      <p class="task-option-modal-text">Do you want to delete "<strong>{{ listDetails.toDoListName }}</strong>"? All of
        the tasks and collaborators participated in the list will be removed.</p>
    </b-modal>

  </div>
</template>

<script>
  import router from "../../../router";
  import {db, storage} from "../../../main";
  import firebase from "firebase";

  export default {
    name: "CollaborativeListCell",
    props: {
      listDetails: Object
    },
    data() {
      return {
        isCollaborativeListOwner: false,
        isTaskOptionsButtonShown: false,
        isOwnerLeaveListModalShown: false,
        isGeneralLeaveListModalShown: false,
        isDeleteListModalShown: false
      }
    },
    methods: {
      leaveCollaborativeList() {
        // leave the list
        db
          .collection('collaborative_to_do_lists')
          .doc(this.listDetails.toDoListId)
          .update('toDoListCollaboratorId', firebase.firestore.FieldValue.arrayRemove(this.$store.getters.user.data.id))

        // remove all the tasks assigned to the previous owner
        db
          .collectionGroup('tasks')
          .where('assigneeId', '==', this.$store.getters.user.data.id)
          .where('taskType', '==', 'Collaborative Task')
          .get()
          .then(querySnapshot => {
            querySnapshot.docs.map(doc => doc.ref.update({
              assigned: false,
              assigneeId: null,
              assigneeName: null
            }))
          })

        // remove the owner collaboration from the list
        db
          .collectionGroup('user_collaborative_to_do_list_participation')
          .where('collaboratorId', '==', this.$store.getters.user.data.id)
          .where('collaborativeToDoListId', '==', this.listDetails.toDoListId)
          .get()
          .then(querySnapshot => {
            querySnapshot.docs.map(doc => doc.ref.delete())
          })

        // notify the current users about the user that left the collaborator list
        const date = new Date();
        const notificationCreationTime = date.getTime()

        const notification = {
          collaborativeToDoListId: this.listDetails.toDoListId,
          notificationMessage: this.$store.getters.user.data.displayName.toUpperCase() + " left \"" + this.listDetails.toDoListName + "\"",
          notificationType: 'Leave Collaborative List',
          notificationCreationTime: notificationCreationTime,
          notificationCreationDate: firebase.firestore.FieldValue.serverTimestamp()
        }

        // send the notification to every user EXCEPT the user left
        db
          .collection('collaborative_to_do_lists')
          .doc(this.listDetails.toDoListId)
          .get()
          .then(doc => {
            const toDoListCollaboratorId = doc.data().toDoListCollaboratorId
            toDoListCollaboratorId.forEach(collaboratorId => {
              if (collaboratorId !== this.$store.getters.user.data.id) {
                db
                  .collection('users/' + collaboratorId + '/notifications')
                  .add(notification)
              }
            })
          })

      },
      deleteList() {
        // clear the documents in the sub-collection before deleting the sub-collection
        this.deleteTask()

        // send notification to ALL of the user to notify about the list deletion
        // notify the current users about the user that left the collaborator list
        const date = new Date();
        const notificationCreationTime = date.getTime()

        const notification = {
          collaborativeToDoListId: this.listDetails.toDoListId,
          notificationMessage: "\"" + this.listDetails.toDoListName + "\"" + " has been deleted",
          notificationType: 'Delete Collaborative List',
          notificationCreationTime: notificationCreationTime,
          notificationCreationDate: firebase.firestore.FieldValue.serverTimestamp()
        }

        db
          .collection('collaborative_to_do_lists')
          .doc(this.listDetails.toDoListId)
          .onSnapshot(doc => {
            const collaborativeToDoListObject = doc.data()
            const toDoListCollaboratorId = collaborativeToDoListObject.toDoListCollaboratorId

            toDoListCollaboratorId.forEach(collaboratorId => {
              if (collaboratorId !== this.$store.getters.user.data.id) {
                db.collection('users/' + collaboratorId + '/notifications')
                  .add(notification)
              }
            })

            // after notifying the user, proceed with list deletion
            db
              .collection('collaborative_to_do_lists')
              .doc(this.listDetails.toDoListId)
              .delete()

            db
              .collectionGroup('user_collaborative_to_do_list_participation')
              .where('collaborativeToDoListId', '==', this.listDetails.toDoListId)
              .onSnapshot(querySnapshot => {
                querySnapshot.docs.map(doc => doc.ref.delete())
              })
          })
      },
      deleteTask() {
        // delete image attached to the task before deleting the list
        this.deleteAttachment()

        db
          .collectionGroup('comments')
          .where('toDoListId', '==', this.listDetails.toDoListId)
          .onSnapshot(querySnapshot => {
            querySnapshot.docs.map(doc => doc.ref.delete())

            // after deleting the comment inside the tasks, delete the tasks
            db
              .collectionGroup('tasks')
              .where('toDoListId', '==', this.listDetails.toDoListId)
              .onSnapshot(querySnapshot => {
                querySnapshot.docs.map(doc => doc.ref.delete())
              })
          })
      },
      deleteAttachment() {
        db
          .collectionGroup('tasks')
          .where('toDoListId', '==', this.listDetails.toDoListId)
          .onSnapshot(querySnapshot => {
            const taskObject = querySnapshot.docs.map(doc => doc.data())

            taskObject.forEach(task => {
              const attachmentObject = task.attachment

              if (attachmentObject !== null) {
                const attachment = task.attachment.toString()
                const attachmentRef = storage.refFromURL(attachment)

                attachmentRef.delete()
              }
            })
          })
      },
      checkListOwnership() {
        if (this.listDetails.ownerId === this.$store.getters.user.data.id) {
          this.isCollaborativeListOwner = true
        } else {
          this.isCollaborativeListOwner = false
        }
      },
      navigateToCollaborativeTaskList() {
        router.push({name: 'Collaborative Task List', params: {collaborativeListId: this.listDetails.toDoListId}})
      },
      navigateToTransferListOwnership() {
        router.push({name: 'Transfer List Ownership', params: {collaborativeListId: this.listDetails.toDoListId}})
      }
    },
    mounted() {
      this.checkListOwnership()
    }
  }
</script>

<style scoped>
  .center-align-icon {
    text-align: center;
  }

  .list-card {
    background-color: #212441;
    color: white;
    padding: 1em;
    margin-bottom: 0.75em;
  }

  .list-name-text {
    font-weight: bold;
    margin-bottom: 0.5em;
  }

  .list-description-text {
    font-size: 0.9em;
    margin-bottom: 0;
  }

  .task-option-button {
    display: block;
  }

  .task-option-button:hover {
    cursor: pointer;
  }
</style>
